import { render, staticRenderFns } from "./RoleBlock.vue?vue&type=template&id=25868e2f&scoped=true"
import script from "./RoleBlock.vue?vue&type=script&lang=js"
export * from "./RoleBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25868e2f",
  null
  
)

export default component.exports